import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { useModalService } from "./../../ricos-modals/modal-service-provider.js";
import { DropdownModal } from "./../dropdown-modal/dropdown-modal.js";
import { ListItemSelect } from "./../list-item-select/list-item-select.js";
import { DEFAULT_OPTIONS, NODE_SIZE_BUTTONS } from "./consts.js";
const NodeSizeDropdown = ({
  modalId,
  getSelectedSize,
  onClick,
  options: optionsOverride
}) => {
  const { t, isMobile } = useContext(RicosContext);
  const modalService = useModalService();
  const options = (optionsOverride ?? DEFAULT_OPTIONS).map((option) => NODE_SIZE_BUTTONS[option]);
  return /* @__PURE__ */ React.createElement(
    DropdownModal,
    {
      onCloseButtonClick: () => modalService.closeModal(modalId),
      title: t("ButtonModal_Size_Section"),
      options: options.map(({ icon: Icon, iconSmall: IconSmall, text, commandKey, dataHook }) => /* @__PURE__ */ React.createElement(
        ListItemSelect,
        {
          key: commandKey,
          dataHook,
          prefix: isMobile ? /* @__PURE__ */ React.createElement(Icon, null) : /* @__PURE__ */ React.createElement(IconSmall, null),
          title: t(text),
          selected: commandKey === getSelectedSize(),
          onSelect: () => onClick(commandKey)
        }
      ))
    }
  );
};
export {
  NodeSizeDropdown
};
//# sourceMappingURL=node-size-dropdown.js.map
